import { makeStyles, tokens } from '@fluentui/react-components';

export const useRuntimeVersionTabStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalL,
  },
  currentVersionSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
    flexWrap: 'wrap',
    paddingBlockEnd: tokens.spacingVerticalM,
    borderBottom: `1px solid ${tokens.colorNeutralStroke2}`,
  },
  currentVersionDetails: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    minWidth: 0,
  },
  currentVersionBadge: {
    backgroundColor: tokens.colorBrandBackground,
    color: tokens.colorNeutralForegroundOnBrand,
    fontWeight: tokens.fontWeightSemibold,
    fontSize: tokens.fontSizeBase300,
    paddingBlock: tokens.spacingVerticalXS,
    paddingInline: tokens.spacingHorizontalM,
    border: '1px solid transparent',
    '@media (forced-colors: active)': {
      backgroundColor: 'Highlight',
      color: 'HighlightText',
      border: '1px solid Highlight',
    },
  },
  versionPickerArea: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  versionOption: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    gap: tokens.spacingHorizontalM,
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderRadius: tokens.borderRadiusLarge,
    backgroundColor: tokens.colorNeutralBackground1,
    paddingBlock: tokens.spacingVerticalM,
    paddingInline: tokens.spacingHorizontalM,
    transitionProperty: 'border-color, background-color, box-shadow',
    transitionDuration: tokens.durationFast,
    transitionTimingFunction: tokens.curveEasyEase,
    ':hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
    '@media (prefers-reduced-motion: reduce)': {
      transitionDuration: '0.01ms',
    },
  },
  versionOptionSelected: {
    border: `2px solid ${tokens.colorBrandStroke1}`,
    backgroundColor: tokens.colorBrandBackground2,
    '@media (forced-colors: active)': {
      border: '2px solid Highlight',
      backgroundColor: 'Canvas',
    },
  },
  versionRadio: {
    width: '100%',
  },
  versionOptionContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    minWidth: 0,
  },
  versionOptionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    flexWrap: 'wrap',
  },
  currentTagIndicator: {
    backgroundColor: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground1,
    fontWeight: tokens.fontWeightSemibold,
    border: `1px solid ${tokens.colorBrandStroke1}`,
    '@media (forced-colors: active)': {
      backgroundColor: 'Highlight',
      color: 'HighlightText',
      border: '1px solid Highlight',
    },
  },
  updateButtonArea: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: tokens.spacingHorizontalM,
    flexWrap: 'wrap',
  },
  progressSection: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: tokens.spacingHorizontalM,
    paddingBlock: tokens.spacingVerticalM,
    paddingInline: tokens.spacingHorizontalM,
    borderRadius: tokens.borderRadiusLarge,
    backgroundColor: tokens.colorNeutralBackground2,
  },
  progressCopy: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
    minWidth: 0,
  },
  registryInfoText: {
    color: tokens.colorNeutralForeground3,
    overflowWrap: 'anywhere',
  },
  stateBar: {
    width: '100%',
  },
  stateBody: {
    wordBreak: 'break-word',
  },
  loadingState: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  loadingRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
  },
  skeletonBadge: {
    width: '112px',
    height: '32px',
    borderRadius: tokens.borderRadiusLarge,
  },
  skeletonLineShort: {
    width: '160px',
    height: '14px',
    borderRadius: tokens.borderRadiusMedium,
  },
  skeletonLineLong: {
    width: '100%',
    maxWidth: '360px',
    height: '14px',
    borderRadius: tokens.borderRadiusMedium,
  },
  skeletonOption: {
    width: '100%',
    height: '56px',
    borderRadius: tokens.borderRadiusLarge,
  },
  emptyState: {
    color: tokens.colorNeutralForeground3,
  },
  customImageField: {
    paddingInline: tokens.spacingHorizontalM,
  },
  dialogSurface: {
    maxWidth: '520px',
  },
  confirmationSummary: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },
  confirmationRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    flexWrap: 'wrap',
  },
});